import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

const ShippingInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <div className="mt-2 md:mt-4 mb-6">
            <button
                className="w-full flex justify-between items-center p-4 text-left bg-white/5 dark:bg-brand-charcoal/30 backdrop-blur-md rounded-lg border border-white/10 hover:bg-white/10 dark:hover:bg-brand-charcoal/40 transition-all duration-200"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-lg font-semibold text-black dark:text-white">
                    {t('shipping.title')}
                </span>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`text-black dark:text-white transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>
            
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10, height: 0 }}
                        animate={{ opacity: 1, y: 0, height: "auto" }}
                        exit={{ opacity: 0, y: -10, height: 0 }}
                        transition={{ duration: 0.2, ease: "easeInOut" }}
                        className="overflow-hidden"
                    >
                        <div className="mt-4 p-6 bg-white/5 dark:bg-brand-charcoal/30 backdrop-blur-md rounded-lg border border-white/10">
                            <div className="space-y-4">
                                <div>
                                    <h4 className="text-base font-semibold text-black dark:text-white mb-2">
                                        {t('shipping.readyToShip')}
                                    </h4>
                                    <p className="text-sm text-gray-700 dark:text-gray-300">
                                        {t('shipping.readyToShipDesc')}
                                    </p>
                                    <ul className="mt-2 space-y-1 text-sm text-gray-700 dark:text-gray-300">
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.express')}
                                        </li>
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.standard')}
                                        </li>
                                    </ul>
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-amber-600 dark:text-amber-500 mb-2">
                                        {t('shipping.madeToOrder')}
                                    </h4>
                                    <p className="text-sm text-gray-700 dark:text-gray-300">
                                        {t('shipping.madeToOrderDesc')}
                                    </p>
                                    <ul className="mt-2 space-y-1 text-sm text-gray-700 dark:text-gray-300">
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.madeToOrderProduction')}
                                        </li>
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.madeToOrderShipping')}
                                        </li>
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.madeToOrderRates')}
                                        </li>
                                    </ul>
                                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 italic">
                                        {t('shipping.madeToOrderContact')}
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-black dark:text-white mb-2">
                                        {t('shipping.costs')}
                                    </h4>
                                    <p className="text-sm text-gray-700 dark:text-gray-300">
                                        {t('shipping.freeOver200')}
                                    </p>
                                    <p className="text-sm text-gray-700 dark:text-gray-300 mt-1">
                                        {t('shipping.under200')}
                                    </p>
                                    <ul className="mt-2 space-y-1 text-sm text-gray-700 dark:text-gray-300">
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.standardCost')}
                                        </li>
                                        <li className="flex items-center gap-2">
                                            • {t('shipping.expressCost')}
                                        </li>
                                    </ul>
                                </div>
                                
                                <p className="text-sm text-gray-700 dark:text-gray-300 mt-4">
                                    {t('shipping.europeOnly')}
                                </p>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ShippingInfo;